import * as React from "react";
const SvgNetwork = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M1 18a.97.97 0 0 1-.712-.288A.97.97 0 0 1 0 17v-.575q0-1.075 1.1-1.75T4 14q.325 0 .625.012.3.014.575.063-.35.525-.525 1.1a4.1 4.1 0 0 0-.175 1.2V18zm6 0a.97.97 0 0 1-.713-.288A.97.97 0 0 1 6 17v-.625q0-.799.438-1.463.437-.662 1.237-1.162.799-.5 1.913-.75 1.112-.25 2.412-.25 1.325 0 2.438.25 1.112.25 1.912.75t1.225 1.162.425 1.463V17q0 .424-.288.712A.97.97 0 0 1 17 18zm12.5 0v-1.625q0-.65-.163-1.225a4 4 0 0 0-.487-1.075q.274-.05.563-.062Q19.7 14 20 14q1.8 0 2.9.662 1.1.663 1.1 1.763V17q0 .424-.288.712A.97.97 0 0 1 23 18zM8.125 16H15.9q-.25-.5-1.388-.875T12 14.75t-2.512.375T8.125 16M4 13q-.824 0-1.412-.588A1.93 1.93 0 0 1 2 11q0-.85.587-1.425A1.95 1.95 0 0 1 4 9q.85 0 1.425.575T6 11q0 .825-.575 1.412A1.91 1.91 0 0 1 4 13m16 0q-.824 0-1.413-.588A1.93 1.93 0 0 1 18 11q0-.85.587-1.425A1.95 1.95 0 0 1 20 9q.85 0 1.425.575T22 11q0 .825-.575 1.412A1.91 1.91 0 0 1 20 13m-8-1a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 9 9q0-1.275.875-2.137T12 6q1.275 0 2.137.862Q15 7.726 15 9q0 1.25-.863 2.125Q13.276 12 12 12m0-2q.424 0 .713-.287A.97.97 0 0 0 13 9a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 8a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 9q0 .424.287.713.288.287.713.287"
    />
  </svg>
);
export default SvgNetwork;
